import React, { useContext, useEffect, useState } from "react";
import { Alert, Dialog, Table } from "../../../layout";
import { Button } from "../../../controls";
import { IconButton, Tooltip } from "@mui/material";
import { ClearRounded, EditRounded } from "@mui/icons-material";
import AddEditBrand from "./AddEditBrand";
import { AppContext } from "../../../App";
import { API, action, controller } from "../../../api/api";

const Brands = () => {
  const [updData, setUpdData] = useState();
  const { authUser, setLoader, access } = useContext(AppContext);
  const [showForm, setShowForm] = useState(false);
  const [brands, setBrands] = useState([]);
  const [alert, setAlert] = useState({
    isOpen: false,
    type: "",
    title: "",
    subTitle: "",
  });

  useEffect(() => {
    if (authUser) {
      setLoader(true);
      API(controller.Brand + action.GetAllByOrg).get((res) => {
        res.status === 200 && setBrands([...res.result]);
        setLoader(false);
      });
    }

    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authUser]);

  const handleAddEdit = (data) => {
    setUpdData(data);
    setShowForm(true);
  };

  const handleDlt = (id) => {
    setAlert({
      isOpen: true,
      type: "confirmation",
      title: "Are you sure",
      subTitle: "You want to delete this brand?",
      onConfirm: () => {
        const onComplete = (res) => {
          if (res) {
            if (res && res.status === 200) {
              setAlert({
                isOpen: true,
                type: "success",
                title: "Deleted Successfully",
                subTitle: res.msg,
              });
              setBrands((x) => [...x.filter((j) => j.id !== res.result.id)]);
            } else
              setAlert({
                isOpen: true,
                type: "warning",
                title: "Warning",
                subTitle: res.msg,
              });
          }
        };
        API(controller.Brand).Delete(id, onComplete);
      },
    });
  };

  const ActionComp = (val) =>
    (access?.brand?.edit || access?.brand?.delete) && (
      <div className="border !border-gray-100 flex gap-2 p-[3px] shadow-sm rounded-[12px] w-fit">
        {access?.brand?.edit && (
          <Tooltip title="Edit">
            <IconButton
              onClick={() => handleAddEdit(val)}
              size="small"
              color="primary"
            >
              <EditRounded className="!text-[18px]" />
            </IconButton>
          </Tooltip>
        )}
        {access?.brand?.delete && (
          <Tooltip title="Delete">
            <IconButton
              onClick={() => handleDlt(val.id)}
              size="small"
              color="error"
            >
              <ClearRounded className="!text-[18px]" />
            </IconButton>
          </Tooltip>
        )}
      </div>
    );

  const HeaderComp = () => (
    <div>
      <Button onClick={() => handleAddEdit()}>Add Brand</Button>
    </div>
  );

  return (
    <>
      <Table
        ActionComp={ActionComp}
        HeaderComp={HeaderComp}
        tblHead={[
          { id: "name", label: "Name" },
          { id: "desc", label: "Description" },
          { id: "prod", label: "Number of Products" },
          { id: "createDate", label: "Create Date" },
          { id: "actions", label: "Actions" },
        ]}
        tblData={[
          ...brands.map((j) => ({
            ...j,
            createDate: new Date(j.createDate).toLocaleString(),
          })),
        ]}
      />

      {/* Add Brand Form*/}
      {showForm && (
        <Dialog show={showForm} onClose={false} maxWidth="sm">
          <AddEditBrand
            {...{ setBrands, setShowForm: setShowForm, updData, setAlert }}
          />
        </Dialog>
      )}

      {/* Alert  */}
      <Alert alert={alert} setAlert={setAlert} />
    </>
  );
};

export default Brands;
